import { Link } from "react-router-dom";
import path from "../../../assets/images/logo.svg";
import Logo from "../../atoms/logo";
import { Container } from "./styles";

const Header = () => {
  return (
    <Container >
      <div >
        <Link to="/">
          <Logo src={path} />
        </Link>
      </div>
    
    </Container>
  );
};

export default Header;
